// extracted by mini-css-extract-plugin
export default {"content":"read-more__content___10fq7","toggle":"read-more__toggle___3KSYw","toggle-icon":"read-more__toggle-icon___1cJox"};